import { render } from "./StatusTag.vue?vue&type=template&id=4cc9d226&scoped=true&ts=true"
import script from "./StatusTag.vue?vue&type=script&lang=ts"
export * from "./StatusTag.vue?vue&type=script&lang=ts"

import "./StatusTag.vue?vue&type=style&index=0&id=4cc9d226&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc9d226"]])

export default __exports__